import DefaultSubTemplate from "components/templates/default/DefaultSubTemplate";
import React from "react";

export default React.createContext({
  subTemplate: DefaultSubTemplate,
  getSubTemplate: () => DefaultSubTemplate,
  noSeparator: false,
});
